import React from 'react'
import { SvgIconProps } from '@mui/material'
import Face from '@mui/icons-material/Face'
import Face3 from '@mui/icons-material/Face3'
import Person from '@mui/icons-material/Person'
import { PatientGender } from '@/shared/types/yakurekiCore'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

interface PatientGenderIconProps extends SvgIconProps {
  gender?: PatientGender
}

const PatientGenderIcon: React.FC<PatientGenderIconProps> = ({
  gender,
  ...props
}) => {
  // スケール定数を定義
  const FEMALE_ICON_SCALE = 0.95

  // Notion 流: 性別による色分けはせず、 icon 形状 (Face/Face3/Person) で識別.
  // 視覚的に統一された warm gray のみで表現.
  const defaultColors = {
    male: colorTokens.fg.muted,
    female: colorTokens.fg.muted,
    other: colorTokens.fg.faint,
    default: colorTokens.fg.muted,
  }

  const color =
    props.color || (gender ? defaultColors[gender] : defaultColors.default)

  if (gender === 'female') {
    return (
      <Face3
        {...props}
        sx={{ color, transform: `scale(${FEMALE_ICON_SCALE})`, ...props.sx }}
      />
    )
  }
  if (gender === 'other') {
    return <Person {...props} sx={{ color, ...props.sx }} />
  }
  // デフォルト（男性）
  return <Face {...props} sx={{ color, ...props.sx }} />
}
export default PatientGenderIcon
